import { useFormContext } from 'react-hook-form';

import { FormField, FormNumberInput } from '@/_components';

type CurrencyInputProps = {
  isEditable?: boolean;
  name: string;
  label: string;
  onChange?: (value: string) => void;
  autoFocus?: boolean;
  formItemClassName?: string;
  className?: string;
  isNegativeAllowed?: boolean;
  staticValue?: number;
};

export function FormCurrencyInput({
  isEditable,
  name,
  label,
  formItemClassName,
  className,
  onChange,
  autoFocus,
  staticValue,
}: CurrencyInputProps) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field: { value, onChange: onValueChange } }) => {
        return (
          <FormNumberInput
            formItemClassName={formItemClassName}
            className={className}
            label={label}
            disabled={!isEditable}
            prefix="$"
            decimalScale={2}
            fixedDecimalScale
            thousandSeparator
            autoFocus={autoFocus}
            value={staticValue ?? value}
            onValueChange={(s) => {
              const v = `${s.floatValue ?? ''}`;
              onValueChange(v);
              onChange?.(v);
            }}
          />
        );
      }}
    />
  );
}
